export default "__VITE_ASSET__uTb7rucN__"